import { serialize } from '@/@core/libs/serialize/util'
import Http from './http'

// LIST ALL Sale Pipelines
export const pipelineList = (params = '') => Http.get(`/sale-pipelines${serialize(params)}`)
export const pipelineCreate = (params = '') => Http.post('/sale-pipelines', params)
export const pipelineByID = (params = '') => Http.get(`/sale-pipelines/${params}`)
export const pipelineUpdate = (params = '') => Http.put(`/sale-pipelines/${params.id}`, params)
export const pipelineDestroy = (params = '') => Http.delete(`/sale-pipelines/${params.id}`)
